module.exports = __webpack_public_path__ + "static/media/08.a5632a93.jpg";